import { useEffect, useState } from 'react';
import styled from 'styled-components';

interface ButtonProps {
  $show: boolean;
}

const ScrollTopButton = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const toggleVisible = () => {
    if (window.scrollY > 500) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      toggleVisible();
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Button onClick={scrollTop} $show={isVisible}>
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <path
          d="M12 19V5M5 12l7-7 7 7"
          stroke="#fff"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Button>
  );
};

export default ScrollTopButton;

const Button = styled.button<ButtonProps>`
  display: ${({ $show }) => ($show ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 80px;
  right: 30px;
  z-index: 10;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.secondary};
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  transition: background-color 0.2s;

  &:hover {
    background-color: #4a6877;
  }

  @media ${(props) => props.theme.mediaQuery.mobile} {
    bottom: 60px;
    right: 30px;
    width: 45px;
    height: 45px;

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;
